import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';
const redistributionTempalteSupplierFormSchema = z.object({
  code: z.string().nullable().optional(),
  wyzApiId: z.number(),
  name: z.string().optional(),
  type: z.number(),
  orderable: z.boolean().nullable(),
  overridePriorityIfShorterDelivery: z.boolean().nullable().optional(),
  customName: z.string().nullish(),
  status: z.string(),
  enabled: z.boolean(),
  rankingModelId: z.string().nullish().optional(),
  childCustomerDelivery: z.boolean().optional(),
  bestPriceDelay: z.boolean().nullish().optional(),
  extendedManufConfiguration: z
    .object({
      enabled: z.boolean().nullable(),
      warehouseId: z.string().nullish(),
      displayName: z.string().nullish(),
    })
    .nullish()
    .optional(),
  autoValidation: z.boolean().optional(),
  customerId: z.string().nullish(),
  _internalStock: z.boolean().optional(),
});
export const redistributionSupplierTemplateFormSchema = z.object({
  name: requiredString,
  customerScope: requiredString,
  criteria: z
    .array(
      z.object({
        criterion: z.object({ id: z.string() }),
        values: z.array(requiredString).min(1, { message: REQUIRED_MESSAGE }),
      }),
    )
    .min(1, { message: REQUIRED_MESSAGE }),
  suppliers: z
    .array(redistributionTempalteSupplierFormSchema)
    .min(1, { message: REQUIRED_MESSAGE }),
});

export const redistributionSupplierTemplatePayload =
  redistributionSupplierTemplateFormSchema
    .omit({ criteria: true, customerScope: true, suppliers: true })
    .extend({
      customerScope: z
        .array(
          z.object({
            id: z.string({
              error: (issue) =>
                issue.input === undefined ? REQUIRED_MESSAGE : undefined,
            }),
          }),
        )
        .min(1, REQUIRED_MESSAGE),
      criteria: z.array(
        z.object({
          criterion: z.object({ id: z.string() }),
          values: z.array(
            z.object({
              id: z.string(),
              label: z.string(),
            }),
          ),
        }),
      ),
      suppliers: z.array(
        redistributionTempalteSupplierFormSchema.omit({
          enabled: true,
          _internalStock: true,
        }),
      ),
    });
export const redistributionSupplierTemplateSchema =
  redistributionSupplierTemplateFormSchema
    .omit({ criteria: true, customerScope: true })
    .extend({
      id: z.string(),
      customerScope: z.array(
        z.object({
          id: z.string(),
        }),
      ),
      criteria: z.array(
        z.object({
          criterion: z.object({ id: z.string(), label: z.string() }),
          values: z.array(
            z.object({
              id: z.string(),
              label: z.string(),
            }),
          ),
        }),
      ),
      suppliers: z.array(
        z.object({
          code: z.string().nullable().optional(),
          wyzApiId: z.number(),
          name: z.string().optional(),
          type: z.number(),
          orderable: z.boolean().nullable(),
          overridePriorityIfShorterDelivery: z.boolean().nullable().optional(),
          customName: z.string().nullish(),
          status: z.string(),
          rankingModelId: z.string().nullish().optional(),
          childCustomerDelivery: z.boolean().optional(),
          bestPriceDelay: z.boolean().nullish().optional(),
          extendedManufConfiguration: z
            .object({
              enabled: z.boolean().nullable(),
              warehouseId: z.string().nullish(),
              displayName: z.string().nullish(),
            })
            .nullish()
            .optional(),
          autoValidation: z.boolean().optional(),
          customerId: z.string().nullish(),
          _internalStock: z.boolean().optional(),
        }),
      ),
    });
